import React, { useState, useEffect } from 'react';
import { FECHA_NAC_MIN, FECHA_NAC_MAX } from '../../components/fechaNacimiento';
import axios from '../../axiosConfig';

import { Form, Button, Alert, Modal, Table,InputGroup  } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SelectComponent from '../../components/SelectComponent';
import './CreateDatos.css';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer, toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import estadosMunicipios from '../../components/estadosMunicipios.json';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons



const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado


const CreateDatos = () => {
  const [cedulaError, setCedulaError] = useState(''); 
  const [isCedulaValid, setIsCedulaValid] = useState(false);
  const [cedulaLengthError, setCedulaLengthError] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);  
  const [showUserRoleModal, setShowUserRoleModal] = useState(false); 
  const [showUserSearchModal, setShowUserSearchModal] = useState(false);  // Modal de búsqueda de usuarios

  const [selectedUserId, setSelectedUserId] = useState(null);
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [selectedUserName, setSelectedUserName] = useState(''); // Nombre del usuario seleccionado
  const [showRoleSearchModal, setShowRoleSearchModal] = useState(false);  // Modal de búsqueda de roles
  const [selectedRoleId, setSelectedRoleId] = useState(null);  // ID del rol seleccionado
  const [selectedRoleName, setSelectedRoleName] = useState('');  // Nombre del rol seleccionado
  const [comentario, setComentario] = useState('');
  const [redirectToCursos, setRedirectToCursos] = useState('');
  const [municipiosDisponibles, setMunicipiosDisponibles] = useState([]);  // Municipios que se mostrarán según el estado seleccionado
  const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores

  const [paginatedUsers, setPaginatedUsers] = useState([]); // Usuarios en la página actual
  const [currentPageUsers, setCurrentPageUsers] = useState(1);
  

  const [paginatedRoles, setPaginatedRoles] = useState([]); // Roles en la página actual
  const [currentPageRoles, setCurrentPageRoles] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
  const [sinCedula, setSinCedula] = useState(false);
  const [validated, setValidated] = useState(false);
const [errorsAlert, setErrorsAlert] = useState([]); // array de mensajes


      const userRole = localStorage.getItem('role');


  
  const itemsPerPage = 8; // Elementos por página
  

const initialFormData = {
  cedula_identidad: '',
  nombres: '',
  apellidos: '',
  fecha_nacimiento: '',
  direccion: '',
  direccion_email: '',
  telefono_casa: '',
  telefono_celular: '',
  nacionalidad_id: 2,      // <-- fijo en 2
  genero_id: '',
  grupo_prioritario_id: '',
  estado_id: '',
  procedencia_id: '',
  nivel_instruccion_id: '',
  como_entero_superatec_id: '',
  municipio: '',
  no_cedula: '',
  status: '',
};
const [formData, setFormData] = useState({ ...initialFormData });

  const [filterOptions, setFilterOptions] = useState({
    nivelInstruccionOptions: [],
    estadoOptions: [],
    generoOptions: [],
    grupoOptions: [],
    nacionalidadOptions: [],
    procedenciaOptions: [],
    superatecOptions: [],  
});




  useEffect(() => {
    handleSeleccionar();
    if (showUserSearchModal) {
      getAllUsers();
    } else if (showRoleSearchModal) {
      getAllRoles();
    }
  }, [showUserSearchModal, showRoleSearchModal]);
  
  const [filters, setFilters] = useState({
    username:'',
    name:''
  });

    


  // Al activar "sin cédula", genera código falso
  useEffect(() => {
   
    const fetchCodigoFalso = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/datos-codigo-falso',{
          headers: { Authorization: `Bearer ${token}` }}

        ); // Ajusta la URL si es diferente
        setFormData(prev => ({
          ...prev,
          cedula_identidad: res.data,
        }));
      } catch (error) {
        console.error('Error generando código falso:', error);
      } finally {
      }
    };

    if (formData.no_cedula) {
      fetchCodigoFalso();
    }
  }, [formData.no_cedula]);
  

  const getAllUsers = async (page = 1) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/users-paginate`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page }, // Incluye `page` en los parámetros
        });

        const { data, last_page, current_page } = response.data.users;

        // Actualizar el estado
        setPaginatedUsers(data); // Datos de la página actual
        setCurrentPageUsers(current_page); // Página actual
        setTotalPages(last_page); // Total de páginas
    } catch (error) {
        console.error('Error fetching users:', error);
        toast.error('Error fetching data');
        setPaginatedUsers([]); // Limpia los datos en caso de error
    }
};


const getAllRoles = async (page = 1) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/role-paginate`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page }, // Incluye `page` en los parámetros
        });

        const { data, last_page, current_page } = response.data.roles;

        setPaginatedRoles(data); // Datos de la página actual
        setCurrentPageRoles(current_page); // Página actual
        setTotalPages(last_page); // Total de páginas
    } catch (error) {
        console.error('Error fetching roles:', error);
        toast.error('Error fetching data');
        setPaginatedRoles([]); // Limpia los datos en caso de error
    }
};




const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({ ...prev, [name]: value }));
};


const handleUserPageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllUsers(newPage);
  }
};

const handleRolePageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllRoles(newPage);
  }
};



  
  
  const handleEstadoChange = (e) => {
    const estadoId = e.target.value;
    
    // Encuentra el estado seleccionado en el JSON
    const estadoSeleccionado = estadosMunicipios.find(estado => estado.id_estado === parseInt(estadoId));
    
    // Actualiza los municipios disponibles
    setMunicipiosDisponibles(estadoSeleccionado ? estadoSeleccionado.municipios : []);
    
    // Actualiza el estado seleccionado en formData
    setFormData({
      ...formData,
      estado_id: estadoId,
      municipio: ''  // Reseteamos el municipio al cambiar de estado
    });
  };
  

  const handleSelectUser = (user) => {
    setSelectedUserId(user.id); // Guardar ID del usuario seleccionado
    setSelectedUserName(user.username); // Guardar nombre del usuario seleccionado
    setShowUserSearchModal(false); // Cerrar modal de búsqueda
    setShowConfirmModal(true); // Mostrar el modal de confirmación después de seleccionar un usuario
  };


  const handleSelectRole = (role) => {
    setSelectedRoleId(role.id);  // Guardar ID del rol seleccionado
    setSelectedRoleName(role.name);  // Guardar nombre del rol seleccionado
    setShowRoleSearchModal(false);  // Cerrar modal de búsqueda de roles
    setShowConfirmModal(true);  // Mostrar modal de confirmación
  };
  
  

  const handleConfirmSendRequest = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Error: Token no encontrado');
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };
    const cedula = String(formData.cedula_identidad || '').trim();

    // ── REGLAS DE STATUS ───────────────────────────────────────────────
    // POST: incluir status:false
    // PUT:  NO tocar status (no enviarlo)
    const payloadCreate = { ...formData, status: false };
    const payloadUpdate = { ...formData }; // sin 'status'

    // ── 1) Chequear existencia por cédula ─────────────────────────────
    let existsResp = null;
    try {
      existsResp = await axios.get(`/datos/cedula/${encodeURIComponent(cedula)}`, { headers });
    } catch (checkErr) {
      if (!(checkErr?.response?.status === 404)) throw checkErr; // error real del check
    }

    // ── 2) Crear o actualizar participante ─────────────────────────────
    let participantId = null;

    if (existsResp && existsResp.status === 200) {
      // Existe → PUT (NO tocar status)
      const persona = existsResp.data?.data ?? existsResp.data ?? {};
      participantId =
        persona.id ??
        persona.persona_id ??
        persona.usuario_id ??
        persona.participante_id ??
        null;

      if (participantId) {
        await axios.put(`/datos/${participantId}`, payloadUpdate, { headers });
        toast.success('Participante actualizado con éxito');
      } else {
        // Si el check no trajo ID, hacemos POST para obtener uno (con status:false)
        const createFallback = await axios.post(`/datos`, payloadCreate, { headers });
        participantId = createFallback.data?.id ?? createFallback.data?.data?.id;
        toast.success('Participante creado con éxito');
      }
    } else {
      // No existe → POST (status:false)
      const createRes = await axios.post(`/datos`, payloadCreate, { headers });
      participantId = createRes.data?.id ?? createRes.data?.data?.id;
      toast.success('Participante creado con éxito');
    }

    if (!participantId) throw new Error('No se pudo determinar el ID del participante');

    // ── 3) Lógica de redirección/petición según redirectToCursos ───────
    if (redirectToCursos === true) {
      // NO enviar la petición cuando redirectToCursos es true
      navigate(`/inscribir-cursos/${cedula}`);
      return;
    }

    // redirectToCursos === false → crear petición (status:false en petición)
    const requestData = {
      user_id: userId,
      destinatario_id: selectedUserId || null,
      role_id: selectedRoleId || null,
      zona_id: 13,
      status: false,
      finish_time: null,
      key: participantId,
      comentario: comentario,
    };

    await axios.post(`/peticiones`, requestData, { headers });
    toast.success('Petición creada con éxito');
    navigate('/datos');
  } catch (error) {
    console.error('Error al enviar la solicitud o los datos:', error);
    toast.error('Error al enviar la solicitud o los datos');
  }
};


  
  const handleSeleccionar = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/filter-datos`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const {nivel_instruccion,estado,genero,grupo_prioritario,nacionalidad,procedencia,superatec} = response.data;

        // Guardar las opciones en el estado de filterOptions
        setFilterOptions({
            nivelInstruccionOptions: nivel_instruccion,
            estadoOptions: estado,
            generoOptions: genero,
            grupoOptions:grupo_prioritario,
            nacionalidadOptions:nacionalidad,
            procedenciaOptions:procedencia,
            superatecOptions:superatec,

        });

        console.log("superatec",filterOptions.superatecOptions);
        console.log("procedencia",filterOptions.procedenciaOptions);


        setSelectVisible(true);  // Mostrar los selectores
    } catch (error) {
        console.error('Error fetching filter options:', error);
    }
};



const handleChange = (event) => {
  const { name, value, type, checked } = event.target;

  let updatedValue = value;

  if (name === 'cedula_identidad') {
    updatedValue = value.replace(/^V-/, '');  // Elimina "V-" si ya está presente
    updatedValue = updatedValue.toUpperCase(); // Convertir todo a mayúsculas

    // Permitir solo números y UNA sola 'R'
    const rCount = (updatedValue.match(/R/g) || []).length;
    updatedValue = updatedValue.replace(/[^0-9R]/gi, ''); // Permitir solo números y "R"
    
    if (rCount > 1) {
      updatedValue = updatedValue.replace(/R/g, ''); // Si hay más de una R, eliminarlas
      updatedValue += 'R'; // Volver a añadir solo una R si era válida
    }

    if (updatedValue.length < 7) {
      setCedulaLengthError('La cédula debe tener al menos 7 caracteres.');
      setIsCedulaValid(false);
    } else {
      setCedulaLengthError('');
      setIsCedulaValid(true);
    }
  }

  setFormData(prevState => ({
    ...prevState,
    [name]: type === 'checkbox' ? checked : updatedValue,
  }));
};

// handler
const handleChangeNumber = (e) => {
  const { name, value } = e.target;

  // Permitir solo dígitos
  let newValue = value.replace(/\D/g, "");

  // Evitar que el primer dígito sea 0
  if (newValue.startsWith("0")) {
    newValue = newValue.slice(1);
  }

  // Limitar longitud a 10 caracteres
  if (newValue.length > 10) {
    newValue = newValue.slice(0, 10);
  }

  setFormData((prev) => ({
    ...prev,
    [name]: newValue,
  }));
};




  const handleKeyDown = (e) => {
    // Permitir números, borrar, tabulación, eliminar y la tecla "R" (en mayúscula)
    if (
      e.key !== 'Backspace' &&
      e.key !== 'Tab' &&
      e.key !== 'Delete' &&
      e.key !== 'r' &&
      e.key !== 'R' &&
      !/[0-9]/.test(e.key)
    ) {
      e.preventDefault();
    }
  };

 
const handleSubmit = async (e, redirectToCursos) => {
   e.preventDefault();
  const form = e.currentTarget;        // el <form> que disparó el submit

   // validación manual extra para campos “custom”
  const requiredFields = ['cedula_identidad','nombres','apellidos','fecha_nacimiento','procedencia_id','nivel_instruccion_id']; // agrega aquí los que no son nativos o te fallan
  const missing = requiredFields.filter(
    k => String(formData[k] ?? '').trim() === ''
  );

  // Valida required/pattern/min/max, etc.
  if (!form.checkValidity()) {
    e.stopPropagation();
    setValidated(true);

    // Crea listado legible de errores
    const invalids = Array.from(form.querySelectorAll(':invalid'));
    const msgs = invalids.map(el => {
      const label =
        el.getAttribute('aria-label') ||
        el.labels?.[0]?.innerText ||
        el.name || el.id || 'Campo';
      const msg = el.validationMessage || 'Campo inválido';
      return `${label}: ${msg}`;
    });

    setErrorsAlert(msgs);      // <-- muestra el Alert
    // opcional: toast también (asegúrate de tener <ToastContainer/> en tu app)
    // toast.error('Hay campos obligatorios sin completar.');

    setLoading(false);         // si habías puesto setLoading(true) antes
    invalids[0]?.focus();      // enfoca el primero inválido
    return;                    // corta el submit
  }

  // Si todo está ok, limpia alerta y sigue flujo normal
  setErrorsAlert([]);
  setValidated(true);
  setLoading(true);
  if (missing.length) {
    // toast.error('Completa los campos obligatorios.');
    setLoading(false);
    return;
  }


  setValidated(true);
  setLoading(true);


  try {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Error: Token no encontrado');
      setLoading(false);
      return;
    }

    const cedula = String(formData.cedula_identidad || '').trim();
    const headers = { Authorization: `Bearer ${token}` };

    // 1) Chequear existencia por cédula
    let existsResp = null;
    try {
      existsResp = await axios.get(`/datos/cedula/${encodeURIComponent(cedula)}`, { headers });
    } catch (checkErr) {
      if (!(checkErr?.response?.status === 404)) throw checkErr;
    }
    const exists = !!(existsResp && existsResp.status === 200);
    const persona = exists ? (existsResp.data?.data ?? existsResp.data ?? {}) : null;
    const id =
      persona?.id ??
      persona?.persona_id ??
      persona?.usuario_id ??
      persona?.participante_id ??
      null;

    // 2) Modal (solo NO-ADMIN):
    //    - Abrir modal SOLO cuando redirectToCursos === false && !exists
    if (userRole !== 'admin') {
      const shouldOpenModal = (redirectToCursos === false) && !exists;
      if (shouldOpenModal) {
        setRedirectToCursos(redirectToCursos);
        setShowConfirmModal(true);
        setLoading(false);
        return;
      }
    }

    // 3) Construir payloads según reglas de status:
    //    - Si redirectToCursos === true:
    //         * NO ADMIN y NO existe  -> status:false (crear en estado pendiente)
    //         * ADMIN                 -> status:true
    //    - Si redirectToCursos === false -> status:true
    const statusForCreate =
      redirectToCursos === true
        ? (userRole === 'admin' ? true : false)
        : true;

    const payloadCreate = { ...formData, status: statusForCreate };

    // Para PUT no tocamos el status: lo excluimos del payload
    const { status: _ignoreStatus, ...payloadUpdate } = formData;

    // 4) Guardar
    if (exists) {
      if (!id) {
        toast.error('No se pudo obtener el ID del participante existente.');
        setLoading(false);
        return;
      }
      await axios.put(`/datos/${id}`, payloadUpdate, { headers });
      toast.success('Participante actualizado con Éxito');
    } else {
      await axios.post(`/datos`, payloadCreate, { headers });
      toast.success('Nuevo Participante agregado con Éxito');
    }

    // 5) Redirección
    if (redirectToCursos === true) {
      navigate(`/inscribir-cursos/${cedula}`);
    } else {
      navigate('/datos');
    }
  } catch (error) {
    console.error('Error en submit:', error);
    // Si el backend explica el rechazo (p. ej. fecha de nacimiento fuera de rango), se muestra.
    toast.error(error?.response?.data?.errors?.fecha_nacimiento?.[0] || 'Error al guardar Participante');
  } finally {
    setLoading(false);
  }
};



 const handleBlur = async () => {
  const cedula = String(formData.cedula_identidad || "").trim();
  if (!cedula) return;

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(`/datos/cedula/${encodeURIComponent(cedula)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // existe → marca error y rellena el formulario
    setCedulaError("La cédula ya está registrada.");
    setIsCedulaValid(false);

    const persona = res.data?.data ?? res.data; // ajusta si tu API envuelve datos

    setFormData(prev => {
      const merged = { ...prev };
      // Copia solo las claves que ya existen en tu form (evita meter campos desconocidos)
      for (const k of Object.keys(prev)) {
        if (persona && Object.prototype.hasOwnProperty.call(persona, k) && persona[k] != null) {
          merged[k] = persona[k];
        }
      }
      // asegura que la cédula quede igual a lo escrito
      merged.cedula_identidad = prev.cedula_identidad;
      return merged;
    });
  } catch (error) {
    if (error?.response?.status === 404) {
      // no existe → permitir registro nuevo
      setCedulaError("");
      setIsCedulaValid(true);
    } else {
      console.error("Error checking cedula:", error);
      setCedulaError("Error verificando la cédula.");
      setIsCedulaValid(false);
    }
  }
};

const handleClearForm = () => {
  setFormData({ ...initialFormData }); // spread para asegurar nueva referencia y re-render
  setCedulaError("");
    setIsCedulaValid('');
     setErrorsAlert([]);
     setValidated('');
};


  return (
    
    <div className="row" style={{ marginTop: '50px' }}>
  <div className="col-lg-7 mx-auto"> {/* Centrado del contenido */}
    <div className="card-box" style={{ padding: '20px', width: '80%', margin: '0 auto' }}>
      <meta name="csrf-token" content="{{ csrf_token() }}" />
      <h2 className="mb-2">Agregar Nuevo Participante</h2>
     {errorsAlert.length > 0 && (
  <Alert variant="danger" dismissible onClose={() => setErrorsAlert([])}>
    <strong>Corrige los siguientes campos:</strong>
    <ul className="mb-0">
      {errorsAlert.map((m, i) => <li key={i}>{m}</li>)}
    </ul>
  </Alert>
)}
      <Form noValidate validated={validated} onSubmit={(e) => handleSubmit(e, redirectToCursos)}>
   


            <Row className="g-2">
      <Col md={6}>
        {/* Select: ¿Sin cédula? */}
        <Form.Group controlId="no_cedula">
          <Form.Label>¿Posee Documento?</Form.Label>
          <Form.Select
            value={formData.no_cedula ? 'true' : 'false'}
            onChange={(e) => {
              const value = e.target.value === 'true';
              setFormData(prev => ({
                ...prev,
                no_cedula: value,
                // Reiniciar campos si cambia
                cedula_identidad: value ? prev.cedula_identidad : '',
              }));
            }}
          >
            <option value="false">Si</option>
            <option value="true">No</option>
          </Form.Select>
        </Form.Group>

        {!formData.no_cedula && (
       <Form.Group controlId="doc_group" className="mb-3">
  <Form.Label>Número de Documento</Form.Label>

  <InputGroup hasValidation>
    <Form.Select
      name="nacionalidad_id"
      value={formData.nacionalidad_id ?? ''}
      onChange={handleChange}
      required
      className="flex-grow-0 w-auto"
      style={{ minWidth: 90 }}
      aria-label="Tipo"
    >
      <option value="" disabled>Tipo</option>
      {filterOptions.nacionalidadOptions.map(opt => (
        <option key={opt.id} value={opt.id}>{opt.descripcion}</option>
      ))}
    </Form.Select>

    <Form.Control
      type="text"
      name="cedula_identidad"
      value={formData.cedula_identidad || ''}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      placeholder="123321323"
      maxLength={10}
      required
      isInvalid={!!(cedulaError || cedulaLengthError)}  // usa isInvalid en vez de className manual
      isValid={isCedulaValid}
    />

    <Button
      variant="outline-secondary"
      onClick={handleClearForm}
      title="Limpiar formulario"
      aria-label="Limpiar formulario"
      tabIndex={-1}
    >
      <i className="bi bi-brush" />
    </Button>
  </InputGroup>

  {/* Feedback fuera del InputGroup -> no mueve el botón */}
  {(cedulaError || cedulaLengthError) && (
    <div className="invalid-feedback d-block">
      {cedulaError || 'Documento inválido'}
    </div>
  )}
</Form.Group>



        )}

        {formData.no_cedula && (
          <div className="mt-3">
            <Form.Group controlId="cedula_falsa">
              <Form.Label>Cédula Falsa Generada</Form.Label>
              <Form.Control
                type="text"
                value={formData.cedula_identidad || ''}
                readOnly
              />
             
            </Form.Group>

            <Form.Group controlId="nacionalidad_id" className="mt-3">
              <Form.Label>Nacionalidad</Form.Label>
              <Form.Select
                name="nacionalidad_id"
                value={formData.nacionalidad_id || ''}
                onChange={handleChange}
                required
              >
                <option value="">Seleccione</option>
                <option value="1">Extranjero</option>
                <option value="2">Venezolano</option>
                
              </Form.Select>
              
            </Form.Group>
            
          </div>
        )}
      </Col>
    </Row>

            <Row className="g-2"> 
            <Col md={6}>
            <Form.Group controlId="nombres">
              <Form.Label>Nombres</Form.Label>
              <Form.Control
                type="text"
                name="nombres"
                value={formData.nombres}
                onChange={handleChange}
                maxLength={255}
                required
              />
            </Form.Group>
            <Form.Control.Feedback type="invalid">
  Este campo es obligatorio.
</Form.Control.Feedback>
            </Col>
            <Col md={6}>
            <Form.Group controlId="apellidos">
              <Form.Label>Apellidos</Form.Label>
              <Form.Control
                type="text"
                name="apellidos"
                value={formData.apellidos}
                onChange={handleChange}
                maxLength={255}
                required
              />
            </Form.Group>
            </Col>

            </Row>
            <Form.Group controlId="fecha_nacimiento">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control
                type="date"
                name="fecha_nacimiento"
                min={FECHA_NAC_MIN}
                max={FECHA_NAC_MAX}
                value={formData.fecha_nacimiento}
                onChange={handleChange}
                required
                
              />
            </Form.Group>
            
            <Row className="g-2"> 
            <Col md={6}>
            <SelectComponent
              options={filterOptions.generoOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.genero_id}
              handleChange={handleChange}
              controlId="genero_id"
              label="Género"
              required
            />
            
            </Col>
            
            </Row>
            <Row className="g-2"> 
            <Col md={6}>
              <Form.Group controlId="estado">
                <Form.Label>Estado</Form.Label>
                <Form.Select
                  name="estado_id"
                  value={formData.estado_id}
                  onChange={handleEstadoChange}
                  required
                >
                  <option value="">Seleccione </option>
                  {estadosMunicipios.map(estado => (
                    <option key={estado.id_estado} value={estado.id_estado}>
                      {estado.estado}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group controlId="municipio">
                <Form.Label>Municipio</Form.Label>
                <Form.Select
                  name="municipio"
                  value={formData.municipio}
                  onChange={(e) => setFormData({ ...formData, municipio: e.target.value })}
                  disabled={!municipiosDisponibles.length}  // Deshabilita si no hay municipios disponibles
                  required
                >
                  <option value="">Seleccione un Municipio</option>
                  {municipiosDisponibles.map((municipio, index) => (
                    <option key={index} value={municipio.municipio}>
                      {municipio.municipio}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

            <Form.Group controlId="direccion">
              <Form.Label>Dirección (Opcional)</Form.Label>
              <Form.Control
                as="textarea"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
                maxLength={255}
                
              />
            </Form.Group>

            <Row className="g-2"> 
            
            <SelectComponent
              options={filterOptions.grupoOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.grupo_prioritario_id}
              handleChange={handleChange}
              controlId="grupo_prioritario_id"
              label="Grupo Prioritario"
              required
            />
            </Row>
            <Row className="g-2"> 
            <Col md={6}>
            <SelectComponent
              options={filterOptions.procedenciaOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.procedencia_id}
              handleChange={handleChange}
              controlId="procedencia_id"
              label="Procedencia"
              required
            />
            </Col>
            <Col md={6}>
            <SelectComponent
             options={filterOptions.nivelInstruccionOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.nivel_instruccion_id}
              handleChange={handleChange}
              controlId="nivel_instruccion_id"
              label="Nivel de Instrucción"
              required
            />
            </Col>
            </Row>

            <Form.Group controlId="direccion_email">
              <Form.Label>Dirección Email (Opcional)</Form.Label>
              <Form.Control
                type="email"
                name="direccion_email"
                value={formData.direccion_email}
                onChange={handleChange}
                
              />
            </Form.Group>
            
            <Row className="g-2"> 
            <Col md={6}>
            <Form.Group controlId="telefono_casa">
              <Form.Label>Teléfono de Casa (Opcional)</Form.Label>
              <Form.Control
                type="text"
                name="telefono_casa"
                value={formData.telefono_casa}
                onChange={handleChangeNumber}
                maxLength={30}
              />
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="telefono_celular">
              <Form.Label>Teléfono Celular (Opcional)</Form.Label>
              <Form.Control
                type="text"
                name="telefono_celular"
                value={formData.telefono_celular}
                onChange={handleChangeNumber}
                maxLength={30}
               
              />
            </Form.Group>
            </Col>
            </Row>
            <SelectComponent
              options={filterOptions.superatecOptions}
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.como_entero_superatec_id}
              handleChange={handleChange}
              controlId="como_entero_superatec_id"
              label="¿Cómo se enteró de Superatec? (Opcional)"
            />



            
      <div className="button-container mt-3">
        <Button
          variant="info"
          type="submit"
          className="ms-2"
          
          onClick={(e) => { 

            e.preventDefault();  // Prevenir comportamiento por defecto
            setRedirectToCursos(false);
            handleSubmit(e, false); // Guardar y redirigir a /datos
          }}
        >
          Guardar
        </Button>

        <Button
          variant="secondary"
          onClick={() => navigate('/datos')}  // Volver simplemente redirige a /datos sin lógica adicional
          className="ms-2"
        >
          Volver
        </Button>
         {userRole === 'admin'  || userRole === 'coordinador' || userRole === 'creador-cursos' || userRole === 'empleabilidad'|| userRole === 'corporativo' 
         || userRole === 'servicio-corp' || userRole === 'servicio-com'
           
            || userRole === 'asist-centro' || userRole === 'promotor'? (

              	

        <Button
          variant="success" 
          onClick={(e) => { 
            e.preventDefault();  // Prevenir comportamiento por defecto
            setRedirectToCursos(true);
            handleSubmit(e, true); // Siguiente redirige a /inscribir-cursos
          }}
          className="ms-2"
        >
          Siguiente
        </Button>
         ) : null}

      </div>


      </Form>

      </div>
      </div>
      

      {/* Modal para seleccionar usuario o rol */}
      <Modal show={showConfirmModal && !selectedUserId && !selectedRoleId} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enviar Petición</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Seleccione si desea enviar la petición de Confirmación a un Rol o Usuario en especifico
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUserRoleModal(false)}>
            Cancelar
          </Button>
          <Button variant="warning" onClick={() => {
            setShowUserRoleModal(false);
            setShowUserSearchModal(true);
          }}>
            Buscar Usuario
          </Button>
          <Button variant="info" onClick={() => {
            setShowUserRoleModal(false);
            setShowRoleSearchModal(true);
          }}>
            Buscar Rol
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de búsqueda de usuarios */}
      <Modal show={showUserSearchModal} onHide={() => setShowUserSearchModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Buscar Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="d-flex align-items-center">
          <Form.Control
            name="username"
            type="text"
            placeholder="Buscar por nombre"
            value={filters.username}
            onChange={handleFilterChange}
            className="me-2"
          />
          <Button 
              variant="info me-2" 
              onClick={getAllUsers}
              style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
          >
              <FaSearch className="me-1" /> {/* Ícono de lupa */}
          </Button>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.length > 0 ? (
                  paginatedUsers.map(user => (
                      <tr key={user.id}>
                          <td>{user.id}</td>
                          <td>{user.username}</td>
                          <td>
                          <div className="d-flex justify-content-center align-items-center">

                                <Button variant="info" onClick={() => handleSelectUser(user)} className="me-2">
                                    <i className="bi bi-check2-square"></i>
                                </Button>
                            </div>
                          </td>
                      </tr>
                  ))
              ) : (
                  <tr>
                      <td colSpan="3">No se encontraron usuarios.</td>
                  </tr>
              )}
          </tbody>

          </Table>
          <div className="d-flex justify-content-between mt-3">
          <Button
            variant="secondary"
              onClick={() => handleUserPageChange(currentPageUsers - 1)}
              disabled={currentPageUsers === 1}
          >
              Anterior
          </Button>
          
          <Button
              variant="secondary"
              onClick={() => handleUserPageChange(currentPageUsers + 1)}
              disabled={currentPageUsers === totalPages}
          >
              Siguiente
          </Button>
          


          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUserSearchModal(false)}>
            Cerrar
          </Button>
          <Button variant="light" onClick={() => {
            setShowUserSearchModal(false);
            setShowUserRoleModal(true);
          }}>
            Volver
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de búsqueda de roles */}
      <Modal show={showRoleSearchModal} onHide={() => setShowRoleSearchModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Buscar Rol</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="d-flex align-items-center">
          <Form.Control
            name="name"
            type="text"
            placeholder="Buscar por nombre"
            value={filters.name}
            onChange={handleFilterChange}
            className="me-2" // Margen derecho para separar del botón
            style={{ flex: 1 }} // Ajusta el ancho para que ocupe el espacio disponible
          />
          <Button
            variant="info"
            onClick={getAllRoles}
            style={{ whiteSpace: 'nowrap' }} // Evita que el texto del botón se rompa en varias líneas
          >
            <FaSearch className="me-1" /> Buscar {/* Ícono de lupa */}
          </Button>
        </div>

          <Table striped bordered hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
            {paginatedRoles.length > 0 ? (
                paginatedRoles.map(role => (
                    <tr key={role.id}>
                        <td>{role.id}</td>
                        <td>{role.name}</td>
                        <td>

                            <div className="d-flex justify-content-center align-items-center">

                              <Button variant="info" onClick={() => handleSelectRole(role)} className="me-2">
                                  <i className="bi bi-check2-square"></i>
                              </Button>
                            </div>
                        </td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan="3">No se encontraron roles.</td>
                </tr>
            )}
        </tbody>

          </Table>
          <div className="d-flex justify-content-between mt-3">
          <Button
            variant="secondary"
            onClick={() => handleRolePageChange(currentPageRoles - 1)}
            disabled={currentPageRoles === 1}
        >
            Anterior
        </Button>
         
              <Button
                  variant="secondary"
                  onClick={() => handleRolePageChange(currentPageRoles + 1)}
                  disabled={currentPageRoles === totalPages}
              >
                  Siguiente
              </Button>
           

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRoleSearchModal(false)}>
            Cerrar
          </Button>
          <Button variant="light" onClick={() => {
            setShowRoleSearchModal(false);
            setShowUserRoleModal(true);
          }}>
            Volver
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal de confirmación para enviar la solicitud al usuario */}
      <Modal show={selectedUserId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedUserId
            ? `¿Seguro que deseas enviar la solicitud al usuario ${selectedUserName}?`
            : 'No se ha seleccionado ningún usuario.'}
        </Modal.Body>
        <Form.Group controlId="comentario" style={{ margin: '10px 20px' }}>
          <Form.Label>Comentario (opcional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
            style={{ padding: '5px', resize: 'none' }}
          />
        </Form.Group>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
          <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedUserId}>Confirmar</Button>
          <Button variant="light" onClick={() => {
            setShowConfirmModal(false);
            setShowUserSearchModal(true);
          }}>
            Volver
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmación para enviar la solicitud al rol */}
      <Modal show={selectedRoleId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRoleId
            ? <p>¿Seguro que deseas enviar la solicitud al rol {selectedRoleName}?</p>
            : <p>No se ha seleccionado ningún rol.</p>}
          <Form.Group controlId="comentario" style={{ margin: '10px 0' }}>
            <Form.Label>Comentario (opcional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
              style={{ padding: '5px', resize: 'none' }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
          <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedRoleId}>Confirmar</Button>
          <Button variant="light" onClick={() => {
            setShowConfirmModal(false);
            setShowRoleSearchModal(true);
          }}>Volver</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default CreateDatos;
